import React, {useState, useEffect} from 'react';
import Cookies from 'js-cookie';
import { Pie } from 'react-chartjs-2';
import logoIcon from "../../assets/logo-icon.png";

const translations = {
  en: {
    discBehavioralStyle: "DISC Behavioral Style",
    discModel: "DISC Model",
    showWorkplaceImpact: "Show Workplace Impact",
    showDevelopmentTip: "Show Development Tip",
    workplaceImpact: "Workplace Impact",
    developmentTip: "Development Tip",
    workStyleSummary: "Work Style Summary",
    primaryStyle: "Primary Style"
  },
  nl: {
    discBehavioralStyle: "DISC Gedragsstijl",
    discModel: "DISC Model",
    showWorkplaceImpact: "Toon Werkplek Impact",
    showDevelopmentTip: "Toon Ontwikkelingstip",
    workplaceImpact: "Werkplek Impact",
    developmentTip: "Ontwikkelingstip",
    workStyleSummary: "Werkstijl Samenvatting",
    primaryStyle: "Primaire Stijl"
  }
};

const DISCModel = ({ discData, analysisResults, isRecruiterMode, isGeneratingPDF, isDutch = false }) => {
    const [lang, setLang] = useState(isDutch ? 'nl' : 'en');
    const t = translations[lang];
    const [isBigFiveToggleOpen, setIsbigFiveToggleOpen] = useState(false);

    const chartOptions = {
        plugins: {
            legend: {
                position: 'bottom',
                labels: {
                    padding: 20,
                    usePointStyle: true,
                }
            }
        }
    };

    const discColors = [ 
        '#FFD700', 
        '#FFA500', 
        '#FF8C00',
        '#EA650D', 
        '#E55100',
        '#D84315', 
    ]

    const toggleOpen = () => {
        setIsbigFiveToggleOpen(!isBigFiveToggleOpen);
        Cookies.set('isBigFiveToggleOpen', !isBigFiveToggleOpen)
    };

    useEffect(() => {
        const checkLanguage = () => {
            const cookieIsDutch = Cookies.get('isDutch') === 'true';
            const newLang = cookieIsDutch ? 'nl' : 'en';
            if (newLang !== lang) {
                setLang(newLang);
            }
        };

        // Check immediately
        checkLanguage();

        // Set up an interval to check for changes
        const interval = setInterval(checkLanguage, 1000);

        return () => clearInterval(interval);
    }, [lang]);

    useEffect(() => {
        setIsbigFiveToggleOpen(true)
    }, [isRecruiterMode])

    return (
        <div className="flex flex-col animate-text">
            <div className='flex items-center justify-between gap-2'>
            <h2 className="text-xl font-bold text-primary">
                {isRecruiterMode ? t.discBehavioralStyle : t.discModel}
            </h2>
            {!isGeneratingPDF && (
            <div className="toggle-container !m-0 !gap-2">
            <label className='text-sm'>
            {isRecruiterMode ? t.showWorkplaceImpact : t.showDevelopmentTip}
            </label>
            <input
                type="checkbox"
                checked={isBigFiveToggleOpen}
                onChange={toggleOpen}
                className="theme-checkbox"
                />
            </div>
            )}
            </div>
            <div className="flex-1 border p-4 rounded-md w-full h-fit mt-2 flex flex-col gap-4">
                <div className="w-full h-[300px] flex items-center justify-center animate-text">
                    <Pie data={discData} options={chartOptions} />
                </div>
                <div className="grid grid-cols-2 gap-4 mt-4">
                    {Object.entries(analysisResults?.disc)?.map(([trait, data], index) => (
                        trait !== 'primaryStyle' && trait !== 'workPerformance' &&  trait !== 'workStyleSummary' && (
                          <div className="animate-text flex flex-col" key={index}>
                            <div className='flex-1'>
                            <div className="flex justify-between gap-2 items-center mt-2">
                                <h3 className="font-bold capitalize">{trait}</h3>
                                <p className="text-gray-500 text-sm">{data.score}%</p>
                            </div>
                            <div className="relative w-full h-2 bg-gray-200 rounded mt-2">
                                <div
                                    className="absolute h-full bg-default rounded"
                                    style={{ width: `${(data.score)}%`, backgroundColor: discColors[index] }}
                                />
                            </div>
                                <p className="text-sm text-gray-600 mt-4">{data.interpretation}</p>
                            </div>
                                
                                {isBigFiveToggleOpen && isRecruiterMode ? (
                                    isBigFiveToggleOpen &&  data.workplaceImpact && (
                                        <div className="text-xs mt-4 font-medium p-2 rounded-md gradient-bg-1">
                                            <p><span className="font-semibold">{t.workplaceImpact}:</span> {data.workplaceImpact}</p>
                                        </div>
                                    )
                                ) : (
                                    isBigFiveToggleOpen &&  data.workplaceImpact && (
                                        <div className="text-xs mt-4 font-medium p-2 rounded-md gradient-bg-1">
                                            <p><span className="font-semibold">{t.developmentTip}:</span> {data.developmentTip}</p>
                                        </div>
                                    )
                                )}
                          </div>
                        )
                    ))}
                </div>
                
                {analysisResults.disc.primaryStyle && (
                    <div className="border-t pt-4">
                        <div className='p-4 rounded-md gradient-bg-2 '>
                        <span className="text-primary text-sm font-bold mb-1 mt-neg flex items-center gap-2 bg-white py-1.5 px-3 pr-4 rounded-full w-fit mb-4">
                        <img src={logoIcon} className="size-4" />
                            <h3>{isRecruiterMode ? t.workStyleSummary : t.primaryStyle}</h3>
                        </span>
                        
                        <p className="text-sm mt-2">
                            {isRecruiterMode 
                                ? `${analysisResults?.disc?.primaryStyle}` 
                                : `${analysisResults?.disc?.workStyleSummary}`
                            }
                        </p>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default DISCModel; 